<template>
  <div id="app">
    <v-app>
      
      <div v-if="externalView">
        <router-view :key="$route.name" name="external" />
      </div>
      <div v-else-if="inAppView">

        <!-- PAGES -->
        <div class="pages">
      
          <!-- IF APP IS READY SHOW PAGE, OTHERWISE SHOW SPINNER -->
          <div class="page-content" v-if="app.ready">
            <router-view :key="$route.name" name="app" />
          </div>
          <div v-else class="page-content">
            <div class="center-parent">
              <v-progress-circular style="margin: 0 auto;" indeterminate color="accent" :size="80"></v-progress-circular>
            </div>
          </div>
      
        </div>

        <!-- NAVIGATION -->
        <div class="navigation">

          <!-- DESKTOP NAV -->
          <div class="desktop-nav">
            <vo-navigation></vo-navigation>
          </div>

          <!-- MOBILE NAV -->
          <div class="mobile-nav">
            <vo-navigation-mobile></vo-navigation-mobile>
          </div>
        
        </div>

      </div>
      <div v-else>
        <div class="center-parent">
          <v-progress-circular style="margin: 0 auto;" indeterminate color="accent" :size="80"></v-progress-circular>
        </div>
      </div>

      <!-- Overlays -->
      <vo-dialog-parent :dialogComponent="$route.query.dialog" />
      <vo-gallery />
      <vo-dialog />
      <vo-toast />
      <vo-activity-toast />
      <vo-version-lockout v-if="app.versionLockout" />

    </v-app>
  </div>
</template>

<script>

  import liveUpdateMixin  from '../mixins/liveUpdateMixin'
  import permissionMixin  from '../mixins/permissionMixin'
  import signoutMixin     from '../mixins/signoutMixin'

  export default {
    
    mixins: [liveUpdateMixin, permissionMixin, signoutMixin],

    data: function () {
      return {
      
      }
    },
    
    computed: {

      appPages () {
        return window.appPages;
      },

      externalView () {
        // Logged out view should show when the user is on an external page, or the user is on the main app but not signed in
        return (this.$route.name in window.appPages) || this.$store.getters.profile === false;
      },

      inAppView () {
        // Logged in view should show when the user's profile and company are defined. We can show a logged version of the spinner until the rest of the app is prepared, but the user will at least visually see that they are logged in 
        return this.$store.getters.profile && this.$store.getters.profile._id && this.$store.getters.company._id;
      }

    },
    
    beforeCreate () {

      // Remove Hashbang from route
      if (this.$route.hash && this.$route.hash.indexOf('#/') > -1) {
        this.$router.replace(this.$route.hash.split('#/')[1]);
      }
      else if (this.$route.hash && this.$route.hash.indexOf('#!/') > -1) {
        this.$router.replace(this.$route.hash.split('#!/')[1]);
      }      

      // Check user login
      var token = window.localStorage.token ? JSON.parse(window.localStorage.token) : false;

      // User doesn't have a token in localStorage
      if (!token) {

        // Since the user isn't signed in, we need to enforce that they visit a page that is accessible when not logged in
        var route = 'login';

        // Check appPages to see if this is an external page, which are allowed
        if (this.$route.name in window.appPages) {          
          route = this.$route.name;
        }
        
        // Make sure the store is clear
        this.$store.dispatch('clearStore');

        // Preserve a token
        const query = {};
        if (this.$route.query && this.$route.query.token) query.token = this.$route.query.token;

        // Enforces the user is coming from a page you can access while logged out
        this.$router.replace({
          name: route,
          query: query,
        });
      }
       
      // User has a token in local storage
      else {

        this.$store.commit('storeToken', token);
        this.$store.dispatch('fetchProfile')
        .then(data => {
          return window.AppData.firstLoad();
        })
        .then(data => {
          if (this.$route.path === '/') {
            this.reroute(); // This will find a page the user has access to (usually /tickets, but not necessarily)
          }
        })
        .catch(e => {
          console.log('App.vue - Login error:', e);
        });
      }
    },
    
    created () {
    
      // Strip the query params of anything that shouldn't be defined on first load
      var deleteThese = [];
      if ('dialog' in this.$route.query)        deleteThese.push('dialog');
      if ('dialogAction' in this.$route.query)  deleteThese.push('dialogAction');
      if ('dialogItem' in this.$route.query)    deleteThese.push('dialogItem');
      if ('gallery' in this.$route.query)       deleteThese.push('gallery');
      if (deleteThese.length > 0) {

        var query = {...this.$route.query};
        deleteThese.forEach(key => {
          delete query[key];
        });

        // Replace the query with the stripped version
        this.$router.replace({
          query: query
        });
      }

      // Live Update Event Listener
      
      document.addEventListener('liveUpdate', (e) => {
        this.liveUpdate(e.detail.data);
      });
    }

  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  @import '../css/transitions.scss';

  #app {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $primary;

    .navigation {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;

          
      .mobile-nav {
        display: none;
      }
    }

    .pages {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;

      .page-content {
        position: absolute;
        top: 64px;
        right: 0;
        left: 0;
        bottom: 0;
        background: #FFF;
        overflow: hidden;

        .page-not-found {
          @include fontPrimary400();
          color: $black54;
          text-align: center;
          padding: 24px 16px;
          width: 280px;
          margin: 0 auto;

          div {
            padding: 24px 16px;
          }
        }
      }
    
    }

    @media screen and (max-width: 880px) {
     
     .navigation {
    
        .desktop-nav {
          display: none;
        }
      
        .mobile-nav {
          display: block;
        }
      }

      .pages {
      
        .page-content {
          top: 60px;
        }

      }
      
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/App.vue